module.exports = __webpack_public_path__ + "img/location.8154a101.png";